var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5211 0.488245C8.82829 0.803623 9.0002 1.22648 9.0002 1.66675C9.0002 2.10701 8.82829 2.52987 8.5211 2.84525L3.9511 7.50025L8.5211 12.1552C8.82829 12.4706 9.0002 12.8935 9.0002 13.3337C9.0002 13.774 8.82829 14.1969 8.5211 14.5122C8.37062 14.6668 8.19071 14.7896 7.992 14.8734C7.79328 14.9573 7.57978 15.0005 7.3641 15.0005C7.14842 15.0005 6.93492 14.9573 6.7362 14.8734C6.53748 14.7896 6.35758 14.6668 6.2071 14.5122L0.4791 8.67924C0.171907 8.36387 0 7.94101 0 7.50075C0 7.06048 0.171907 6.63762 0.4791 6.32225L6.2071 0.488245C6.35758 0.333727 6.53748 0.210916 6.7362 0.12706C6.93492 0.043203 7.14842 0 7.3641 0C7.57978 0 7.79328 0.043203 7.992 0.12706C8.19071 0.210916 8.37062 0.333727 8.5211 0.488245Z",
    fill: "#393ABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlueArrow);
export default __webpack_public_path__ + "static/media/back-blue-arrow.258d3fe4fde9d2f065a73e71151b80e6.svg";
export { ForwardRef as ReactComponent };